import { render, staticRenderFns } from "./MttoPrincipal.vue?vue&type=template&id=12b712be&scoped=true&"
import script from "./MttoPrincipal.vue?vue&type=script&lang=js&"
export * from "./MttoPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./MttoPrincipal.vue?vue&type=style&index=0&id=12b712be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b712be",
  null
  
)

export default component.exports